// extracted by mini-css-extract-plugin
module.exports = {"Footer__root":"Ai8m","Footer__text":"tBXF","Footer__item_logo":"hpDe","Footer__item":"HhDq","Footer__title":"q5Nt"};